import React from 'react'
import { InputFloating, SelectFloating } from '../../../components/InputFloating'

interface CustomerBasicInfoProps {
  customer: any
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  handleChangeCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
  user: any
}

export const CustomerBasicInfo: React.FC<CustomerBasicInfoProps> = ({
  customer,
  handleChange,
  handleChangeCheckbox,
  user
}) => {
  return (
    <>
      <div className="row mb-3">
        <div className="col">
          <InputFloating
            type="text"
            label="Nombre o Razón social"
            name="name"
            value={customer.name}
            required={true}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <SelectFloating
            name="documentType"
            label="Tipo de documento"
            options={[{ value: "RUC", text: "RUC" }, { value: "DNI", text: "DNI" }, { value: "CEX", text: "Carnet de extranjería" }]}
            value={customer.documentType}
            handleChange={handleChange}
            required={true}
          />
        </div>
        <div className="col">
          <InputFloating
            type="text"
            label="Número de documento"
            name="documentNumber"
            value={customer.documentNumber}
            onChange={handleChange}
            required={true}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <InputFloating
            type="text"
            label="Dirección"
            name="address"
            value={customer.address}
            required={true}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <InputFloating
            type="text"
            label="Referencia"
            name="reference"
            value={customer.reference}
            required={false}
            onChange={handleChange}
          />
        </div>
      </div>
      {user && user.role !== 'vendedor' &&
        <div className="row mb-3">
          <div className="col">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" name="watched" defaultChecked={customer.watched} onChange={handleChangeCheckbox} id="watched" />
              <label className="form-check-label" htmlFor="watched">
                Observar cliente
              </label>
            </div>
          </div>
        </div>
      }
    </>
  )
}